import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CheckboxComponent } from './checkbox.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
	declarations: [],
	imports: [CheckboxComponent],
	exports: [CheckboxComponent],
})
export class CheckboxModule {}
